import { z } from 'zod';

import { PrimaryKeySchema, commaDelimitedList } from './utils';

export const TeamConversationSchema = z.object({
  teamConversationId: PrimaryKeySchema,
  teamId: PrimaryKeySchema,
  conversationId: PrimaryKeySchema,
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type TeamConversation = z.infer<typeof TeamConversationSchema>;

export const TeamConversationFiltersSchema = z.object({
  teamConversationIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
  teamIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
  conversationIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
});

export type TeamConversationFilters = z.infer<
  typeof TeamConversationFiltersSchema
>;
